<template>
  <div>
    <el-select
      v-model="newValue"
      @change="$emit('set-new-value', { newValue })"
    >
      <el-option
        v-for="selectOption in selectOptions"
        :key="selectOption.label"
        :label="selectOption.value"
        :value="selectOption.value"
      />
    </el-select>
  </div>
</template>

<script lang="ts">
export default {
  name: "BaseSelect",
  props: ["value", "options"],
  emits: {
    "set-new-value"(payload) {
      return !!payload.newValue
    },
  },
  data() {
    return {
      newValue: this.value,
      selectOptions: this.options,
    }
  },
}
</script>